import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon, ArrowRightIcon } from 'lucide-react';
export function About() {
  const approaches = ['Prevention', 'Restoration', 'Empowerment', 'Whole-person care'];
  return <section id="about" className="py-24 bg-white" data-id="element-19">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-21">
          <div className="order-2 lg:order-1" data-id="element-22">
            <div className="relative" data-id="element-23">
              <img src="https://images.unsplash.com/photo-1516585427167-9f4af9627e6c?auto=format&fit=crop&q=80&w=1000" alt="Mental wellness and support" className="rounded-2xl shadow-xl w-full h-[400px] object-cover" data-id="element-24" />
              <div className="absolute -top-4 -right-4 bg-brand-red text-white p-8 rounded-2xl shadow-lg hidden md:block" data-id="element-25">
                <p className="text-3xl font-bold" data-id="element-26">100%</p>
                <p className="text-sm font-medium opacity-90" data-id="element-27">
                  Confidential Care
                </p>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2" data-id="element-28">
            <h2 className="text-brand-red font-bold tracking-wider uppercase text-sm mb-4" data-id="element-29">
              About Us
            </h2>
            <h3 className="text-3xl lg:text-4xl font-bold text-brand-navy mb-6" data-id="element-30">
              True wellness involves caring for both the body and the mind.
            </h3>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-31">
              Global Restorative Health & Wellness LLC is a comprehensive
              provider dedicated to helping individuals and families restore
              their health, rebuild emotional strength, and rediscover purpose.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-32">
              Our integrated approach combines family medical care, health risk
              assessments, mental wellness coaching, critical care consultation,
              and professional training services.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-10" data-id="element-33">
              {approaches.map(item => <div key={item} className="flex items-center space-x-3" data-id="element-34">
                  <CheckCircle2Icon className="h-6 w-6 text-brand-red flex-shrink-0" data-id="element-35" />
                  <span className="text-brand-navy font-semibold" data-id="element-36">{item}</span>
                </div>)}
            </div>

            <Link to="/about" className="inline-flex items-center text-brand-navy font-bold hover:text-brand-red transition-colors group" data-id="element-37">
              Learn More About Our Approach
              <ArrowRightIcon className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-38" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}